var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import IdeasItemSideBarTemplate from '@front/templates/IdeasItemSideBarTemplate.html';
import { ThemeManager } from '../../../misc/ThemeManager';
import { CustomErrorClass, ErrorInformationStorage } from '@shared/commons/ErrorInformationStorage';
import { Resources } from '@shared/localizations/Resources';
import { SolidBrush } from '@shared/commons/Graphics';
import { ModelDataType, TerceraChartMVCCommand } from '@front/chart/TerceraChartMVC';
import { DataCache } from '@shared/commons/DataCache';
import { HistoryType } from '@shared/utils/History/HistoryType';
import { Periods } from '@shared/utils/History/TFInfo';
import { TerceraChartDrawingType } from '@front/chart/Utils/ChartConstants';
import { SlTpPriceType } from '@shared/utils/Enums/Constants';
import { SlTpUtils } from '@shared/utils/Trading/SlTpUtils';
import { ProductType } from '@shared/utils/Instruments/ProductType';
import { InstrumentUtils } from '@shared/utils/Instruments/InstrumentUtils';
import { IsAllowed } from '@shared/commons/IsAllowed';
import { OrderType } from '@shared/utils/Trading/OrderType';
import { ProfitCalculator } from '@shared/commons/cache/ProfitCalculator';
import { Quantity } from '@shared/commons/UtilsClasses/Quantity';
import { SlTpHolder } from '@shared/utils/Trading/SlTpHolder';
import { PlacedFrom } from '@shared/utils/Trading/PlacedFrom';
import { TIF } from '@shared/utils/Trading/OrderTif';
import { OrderEditUpdateData } from '@shared/utils/Trading/OrderEditUpdateData';
import { TradingNumericErrorChecker } from '@shared/commons/Trading/TradingNumericErrorChecker';
import { ContainerControl } from '../../ContainerControl';
import { ControlsTypes } from '../../../UtilsClasses/FactoryConstants';
import { Control } from '../../Control';
import { WDSettings } from '../../../settings/WDGeneralSettings';
import { WDSettingsUtils } from '../../../UtilsClasses/WDGeneralSettingsUtils';
import { LimitOrderType } from '@shared/commons/cache/OrderParams/order-type/LimitOrderType';
import { MessageBoxType } from '@shared/utils/MessageBoxUtils';
import { TerceraMessageBox } from '../../../screen/TerceraMessageBox';
import { OrderEditBaseUtils } from '@shared/utils/Trading/OrderEditBaseUtils';
import { NewContextMenuItemType } from '@shared/utils/ContextMenuUtils';
export class IdeasItemSideBar extends ContainerControl {
    constructor() {
        super(...arguments);
        this.terceraChartRactive = null;
        this.subscribedInstrument = null;
        this.lifeTimeIntervalId = null;
        this.reOpenIdeaAfterNoConfirmClick = () => {
            void this.ideaSelect();
        };
    }
    get chart() {
        var _a, _b;
        return (_b = (_a = this.terceraChartRactive) === null || _a === void 0 ? void 0 : _a.terceraChart) !== null && _b !== void 0 ? _b : null;
    }
    getType() {
        return ControlsTypes.IdeasItemSideBar;
    }
    oninit() {
        super.oninit();
        Control.Ticker.Subscribe(this.TickAsync, this);
    }
    oncomplete() {
        super.oncomplete();
        this.setDataIdea();
        this.localize();
        this.initLifeTimeTimer();
        this.onInstrumentChanged(this.get('instrumentItem'), null);
        this.on('placeOrder', (ctx) => {
            var _a, _b;
            (_b = (_a = ctx === null || ctx === void 0 ? void 0 : ctx.original) === null || _a === void 0 ? void 0 : _a.stopPropagation) === null || _b === void 0 ? void 0 : _b.call(_a);
            void this.placeOrder();
        });
        this.on('fileClick', (ctx) => this.attachmentClick(false, ctx));
        this.on('screenClick', (ctx) => this.attachmentClick(true, ctx));
        this.on('timeFrameComboBox_ComboItemClicked', this.onTimeFrameComboBox_ComboItemClicked);
        this.observe('productType', this.onProductTypeChanged);
        this.observe('instrumentItem', this.onInstrumentChanged);
        this.observe('account', this.onAccountChanged);
        this.observe('isCashQtyMode', this.onIsCashModeChanged);
        this.observe('account quantity estQtyValue', this.recountLossAndProfit);
        void this.set('srcFromLogoBytes', (logoBytes) => this.srcFromLogoBytes(logoBytes));
        void this.set('orderType', new LimitOrderType()); // for OEQuantity when CashTrading mode enabled
    }
    ideaOpen(ctx) {
        var _a, _b;
        (_b = (_a = ctx === null || ctx === void 0 ? void 0 : ctx.original) === null || _a === void 0 ? void 0 : _a.stopPropagation) === null || _b === void 0 ? void 0 : _b.call(_a);
        this.fire('ideaOpen');
    }
    ideaHeaderClick(ctx) {
        var _a, _b;
        if (!this.get('isOpenIdea'))
            return;
        (_b = (_a = ctx === null || ctx === void 0 ? void 0 : ctx.original) === null || _a === void 0 ? void 0 : _a.stopPropagation) === null || _b === void 0 ? void 0 : _b.call(_a);
        this.fire('ideaClose');
    }
    ideaClose(ctx) {
        var _a, _b;
        (_b = (_a = ctx === null || ctx === void 0 ? void 0 : ctx.original) === null || _a === void 0 ? void 0 : _a.stopPropagation) === null || _b === void 0 ? void 0 : _b.call(_a);
        this.fire('ideaClose');
    }
    descriptionToggle(ctx) {
        var _a, _b;
        (_b = (_a = ctx === null || ctx === void 0 ? void 0 : ctx.original) === null || _a === void 0 ? void 0 : _a.stopPropagation) === null || _b === void 0 ? void 0 : _b.call(_a);
        this.fire('descriptionToggle');
    }
    onMouseDown(event) {
        super.onMouseDown(event, false);
    }
    onteardown() {
        var _a, _b;
        Control.Ticker.UnSubscribe(this.TickAsync, this);
        this.unsubscribe();
        const instrument = this.get('instrumentItem');
        if (!isNullOrUndefined(instrument)) {
            instrument.RiskSettingsUpdated.UnSubscribe(this.instrumentSettingsUpdate, this);
        }
        if (!isNullOrUndefined(this.lifeTimeIntervalId)) {
            clearInterval(this.lifeTimeIntervalId);
            this.lifeTimeIntervalId = null;
        }
        (_b = (_a = this.chart) === null || _a === void 0 ? void 0 : _a.Dispose) === null || _b === void 0 ? void 0 : _b.call(_a);
    }
    TickAsync() {
        var _a;
        if ((_a = this.chart) === null || _a === void 0 ? void 0 : _a.needRedraw) {
            this.chart.needRedraw = false;
            this.chart.Draw();
        }
    }
    themeChange() {
        this.initChartTheme();
    }
    newQuote(_quote) {
        /* TODO document why this method 'newQuote' is empty */
    }
    applyCursor(cursor) {
        if (!isNullOrUndefined(this.terceraChartRactive)) {
            this.terceraChartRactive.setCursor(cursor);
        }
    }
    openByParent() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.ideaSelect();
        });
    }
    closeByParent() {
        this.ideaHide();
    }
    placeOrder() {
        return __awaiter(this, void 0, void 0, function* () {
            if (TradingNumericErrorChecker.HasErrors(this))
                return;
            const idea = this.get('idea');
            const quantity = this.get('quantity');
            if (isNullOrUndefined(idea) || isNullOrUndefined(quantity))
                return;
            const orderType = OrderType.Limit;
            const orderTypeObj = DataCache.OrderParameterContainer.OrderTypes[orderType];
            const orderEditCtorData = {
                dataCache: DataCache
            };
            const orderEdit = orderTypeObj.createOrderEditObject(orderEditCtorData);
            const instrument = this.get('instrumentItem');
            const { cash, isCashQtyMode, estQtyValue } = this.get();
            orderEdit.updateParameters(new OrderEditUpdateData(null, {
                account: this.get('account'),
                instrument,
                side: idea.side,
                cash,
                isCashQtyMode,
                estQtyValue,
                quantity,
                tif: new TIF(idea.tif, idea.tifExpireAt),
                productType: this.get('productType'),
                leverageValue: this.get('leverageValue'),
                placedFrom: PlacedFrom.TRADING_IDEA_CARD
            }));
            orderEdit.setLimitPrice(idea.limitPrice);
            const sltpHolder = new SlTpHolder();
            const offsetType = WDSettings.isSlTpInOffset ? SlTpPriceType.Offset : SlTpPriceType.Absolute;
            sltpHolder.StopLossPriceValue = idea.slPriceToShow;
            sltpHolder.StopLossPriceType = idea.slPriceType === SlTpPriceType.TrOffset ? idea.slPriceType : offsetType;
            if (!isNullOrUndefined(idea.sllPriceToShow)) {
                sltpHolder.StopLossLimitPriceValue = idea.sllPriceToShow;
            }
            sltpHolder.TakeProfitPriceValue = idea.tpPriceToShow;
            sltpHolder.TakeProfitPriceType = offsetType;
            orderEdit.setSLTP({ sltpHolder });
            return yield DataCache.FOrderExecutor.placeOrderPromise(orderEdit, null, null, this.reOpenIdeaAfterNoConfirmClick.bind(this))
                .catch(() => {
                const ex = new CustomErrorClass('IdeasPanel error', 'IdeasPanel.placeOrder', 'placeOrder -> placeOrderPromise');
                ErrorInformationStorage.GetException(ex);
            })
                .finally(() => {
                orderEdit.dispose();
            });
        });
    }
    onInstrumentChanged(instrument, lastInstrument) {
        if (isNullOrUndefined(instrument) || instrument === lastInstrument)
            return;
        this.subscribeRiskSettingsUpdate(instrument, lastInstrument);
        this.instrumentSettingsUpdate();
    }
    subscribeRiskSettingsUpdate(instrument, lastInstrument) {
        if (!isNullOrUndefined(lastInstrument)) {
            lastInstrument.RiskSettingsUpdated.UnSubscribe(this.instrumentSettingsUpdate, this);
        }
        if (!isNullOrUndefined(instrument)) {
            instrument.RiskSettingsUpdated.Subscribe(this.instrumentSettingsUpdate, this);
        }
    }
    attachmentClick(isScreenShot, ev) {
        var _a, _b;
        const idea = this.get('idea');
        if (isNullOrUndefined(idea))
            return;
        (_b = (_a = ev.original) === null || _a === void 0 ? void 0 : _a.stopPropagation) === null || _b === void 0 ? void 0 : _b.call(_a);
        const url = isScreenShot ? idea.AttachmentScreenPath : idea.AttachmentFilePath;
        if (isValidString(url)) {
            window.open(url);
        }
    }
    instrumentSettingsUpdate() {
        const instrument = this.get('instrumentItem');
        const account = this.get('account');
        if (isNullOrUndefined(instrument))
            return;
        if (!isNullOrUndefined(account)) {
            void this.set('tradingAllowed', IsAllowed.IsTradingAllowed(account, instrument, OrderType.Limit).Allowed);
        }
    }
    recountLossAndProfit() {
        var _a, _b;
        const idea = this.get('idea');
        const qtyObj = this.get('quantity');
        if (isNullOrUndefined(idea) || !isValidNumber(qtyObj === null || qtyObj === void 0 ? void 0 : qtyObj.value))
            return;
        const ins = idea.instrument;
        const acc = (_a = this.get('account')) !== null && _a !== void 0 ? _a : DataCache.getPrimaryAccount();
        const isBuy = idea.buySide;
        const crossPrice = DataCache.CrossRateCache.GetCrossPriceInsSideExp2(acc, ins, idea.side);
        const price = idea.limitPrice;
        const toVisual = (value, priceType) => WDSettingsUtils.IsTicksFractionalForForex() && priceType !== SlTpPriceType.Absolute
            ? SlTpUtils.toVisualValue(value, ins, SlTpUtils.getVisualOffsetType(ins, priceType))
            : value;
        const slPrice = toVisual(idea.slPrice, idea.slPriceType);
        const sllPrice = toVisual(idea.sllPrice, idea.slPriceType) * Math.sign((_b = idea.sllPrice) !== null && _b !== void 0 ? _b : 1);
        const tpPrice = toVisual(idea.tpPrice, idea.tpPriceType);
        const finalSL = this.calculateSLPrice(idea, slPrice, sllPrice, price, isBuy, ins);
        const finalTP = this.calculateTPPrice(idea, tpPrice, price, isBuy, ins);
        const qtyInLots = this.get('isCashQtyMode') ? this.get('estQtyValue') : Quantity.toLots(qtyObj, ins);
        idea.slProfit = acc.formatPrice(ProfitCalculator.CalculateSLTP(qtyInLots, finalSL, price, ins, acc, isBuy, crossPrice, null));
        idea.tpProfit = acc.formatPrice(ProfitCalculator.CalculateSLTP(qtyInLots, finalTP, price, ins, acc, isBuy, crossPrice, null));
        void this.set('idea', idea);
        this.setDataIdea();
    }
    calculateSLPrice(idea, slPrice, sllPrice, price, isBuy, ins) {
        if (idea.slPriceType !== SlTpPriceType.Absolute) {
            if (!isNullOrUndefined(sllPrice)) {
                slPrice += sllPrice;
            }
            return ins.calculatePrice(price, slPrice * (isBuy ? -1 : 1));
        }
        return isNullOrUndefined(sllPrice) ? slPrice : sllPrice;
    }
    calculateTPPrice(idea, tpPrice, price, isBuy, ins) {
        if (idea.tpPriceType !== SlTpPriceType.Absolute) {
            return ins.calculatePrice(price, tpPrice * (isBuy ? 1 : -1));
        }
        return tpPrice;
    }
    onAccountChanged(acc, lastAcc) {
        if (isNullOrUndefined(acc) || acc === lastAcc)
            return;
        this.instrumentSettingsUpdate();
        const ins = this.get('instrumentItem');
        if (!isNullOrUndefined(ins)) {
            void this.set('productTypeShow', ins.isProductTypeVisible(acc));
        }
        if (this.chart) {
            this.chart.chartController.ExecuteCommand(new TerceraChartMVCCommand(ModelDataType.Account), acc);
        }
    }
    onProductTypeChanged(newValue, oldValue) {
        if (isNullOrUndefined(oldValue) || isNullOrUndefined(newValue))
            return;
        const idea = this.get('idea');
        if (isNullOrUndefined(idea))
            return;
        const ideaProductType = idea.productTypeAnal;
        const availableProductTypes = InstrumentUtils.getAllowedProductTypeDict(WDSettingsUtils.selectedTradingSymbol);
        if (isNullOrUndefined(ideaProductType) || !availableProductTypes.includes(ideaProductType))
            return;
        if (ideaProductType !== newValue) {
            const msgText = Resources.getResource(newValue === ProductType.Intraday
                ? 'panel.Ideas.productTypeChangeToIntraday'
                : 'panel.Ideas.productTypeChangeToDelivery');
            void this.set('productTypeChangeConfirmationIsInFocus', true);
            TerceraMessageBox.Show(Resources.getResource('general.trading.confirmation'), msgText, MessageBoxType.Question, () => {
                // Yes CALLBACK
                void this.set('productTypeChangeConfirmationIsInFocus', false);
                this.setFocus();
            }, () => {
                // No CALLBACK
                void this.set('productType', oldValue);
                void this.set('productTypeChangeConfirmationIsInFocus', false);
                this.setFocus();
            });
        }
    }
    onIsCashModeChanged(isCashMode, _wasCashMode) {
        if (isCashMode) {
            if (isNullOrUndefined(this.get('cash'))) {
                void this.set('cash', 1);
            }
        }
        this.recountLossAndProfit();
    }
    setDataIdea() {
        const idea = this.get('idea');
        if (isNullOrUndefined(idea))
            return;
        void this.set({
            name: idea.name,
            title: idea.title,
            companyName: idea.companyName,
            instrumentLabel: idea.instrumentLabel,
            buySide: idea.buySide,
            logoSrcBytes: idea.logoSrcBytes,
            lifeTime: idea.lifeTime,
            descriptionParsedToHTML: idea.descriptionParsedToHTML,
            tpPriceToShowFormatted: idea.tpPriceToShowFormatted,
            tpProfit: idea.tpProfit,
            limitPriceToShow: idea.limitPriceToShow,
            slPriceToShowFormatted: idea.slPriceToShowFormatted,
            slProfit: idea.slProfit,
            hasAttachments: idea.hasAttachments,
            AttachmentFilePath: idea.AttachmentFilePath,
            attachExtension: idea.attachExtension,
            AttachmentScreenPath: idea.AttachmentScreenPath,
            side: idea.side,
            orderEditParameterArray: [{ name: OrderEditBaseUtils.LIMIT_PRICE_PARAM, value: idea.limitPrice }],
            wasNotRead: idea.wasNotRead
        });
    }
    initLifeTimeTimer(onlyClear = false) {
        if (!isNullOrUndefined(this.lifeTimeIntervalId)) {
            clearInterval(this.lifeTimeIntervalId);
        }
        if (onlyClear)
            return;
        this.ideasLifeTimeUpdate(); // чтобы при открытии уже были правильные лайфтаймы, а не через секунду
        this.lifeTimeIntervalId = setInterval(this.ideasLifeTimeUpdate.bind(this), 1000);
    }
    ideasLifeTimeUpdate() {
        const idea = this.get('idea');
        if (isNullOrUndefined(idea))
            return;
        const isOpenIdea = this.get('isOpenIdea');
        const lifeTimeTicks = idea.expireTime - Date.now();
        idea.lifeTime = lifeTimeTicks;
        if (isOpenIdea && lifeTimeTicks <= 0) {
            void this.set('tradingAllowed', false);
            void this.set('tradingForbiddenReason', 'Lifetime expired');
        }
        void this.set('idea', idea);
        this.setDataIdea();
    }
    ideaSelect() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.get('isOpenIdea'))
                return;
            const idea = this.get('idea');
            if (isNullOrUndefined(idea))
                return;
            if (idea.wasNotRead) {
                idea.wasNotRead = false;
                const tradingSignalId = idea.id;
                DataCache.SendTradingSignalSeenRequest(tradingSignalId);
            }
            void this.set('idea', idea);
            this.setDataIdea();
            const ins = idea.instrument;
            const productType = idea.productTypeAnal;
            if (!isNullOrUndefined(productType)) {
                void this.set('productType', productType);
            }
            const acc = this.get('account');
            void this.set({
                instrumentItem: ins,
                productTypeShow: ins.isProductTypeVisible(acc), // && productType,  // есть баг видимости productTypeSelector для кейса : аналитику доступен только General, а подписчику Intraday/Delivery, так что тут судя по всему лучше устанавливать видимость только по инструменту
                tradingAllowed: true
            });
            this.setPricesToShow();
            yield this.set('isOpenIdea', true);
            this.onrender();
            this.initChart(ins);
        });
    }
    calculatePriceToShow(options) {
        const { mainPrice, sllPrice, price, priceType, isInOffset, sltpOffsetMode, isBuy, ins } = options;
        let needConvert = isInOffset !== sltpOffsetMode;
        if (priceType === SlTpPriceType.TrOffset)
            needConvert = false;
        const sign = isBuy ? -1 : 1;
        let main = mainPrice;
        let sll = sllPrice;
        if (needConvert) {
            main = isInOffset
                ? ins.calculatePrice(price, mainPrice * sign)
                : ins.calculateTicks(price, mainPrice - price);
            if (!isNullOrUndefined(sllPrice)) {
                const sllVal = (sllPrice + mainPrice) * sign;
                sll = isInOffset ? ins.calculatePrice(price, sllVal) : ins.calculateTicks(price, sllPrice - price);
            }
        }
        if (isInOffset) {
            main = SlTpUtils.toVisualValue(main, ins, SlTpUtils.getVisualOffsetType(ins, priceType));
            if (!isNullOrUndefined(sll)) {
                sll = SlTpUtils.toVisualValue(sll, ins, SlTpUtils.getVisualOffsetType(ins, priceType)) * Math.sign(sll);
            }
        }
        return { main, sll };
    }
    formatPrices(options) {
        const { idea, sl, tp, ins, slType, slOffsetType, tpOffsetType, sltpOffsetMode } = options;
        idea.slPriceToShow = sl.main;
        idea.sllPriceToShow = sl.sll;
        idea.tpPriceToShow = tp;
        if (sltpOffsetMode) {
            idea.slPriceToShowFormatted = SlTpUtils.formatSLTPValue(sl.main, ins, slOffsetType);
            if (!isNullOrUndefined(sl.sll)) {
                idea.slPriceToShowFormatted += '/' + SlTpUtils.formatSLTPValue(sl.sll, ins, slOffsetType);
            }
            idea.tpPriceToShowFormatted = SlTpUtils.formatSLTPValue(tp, ins, tpOffsetType);
        }
        else {
            idea.slPriceToShowFormatted =
                slType === SlTpPriceType.TrOffset
                    ? SlTpUtils.formatSLTPValue(sl.main, ins, slOffsetType)
                    : ins.formatPrice(sl.main);
            if (!isNullOrUndefined(sl.sll) && slType !== SlTpPriceType.TrOffset) {
                idea.slPriceToShowFormatted += '/' + ins.formatPrice(sl.sll);
            }
            idea.tpPriceToShowFormatted = ins.formatPrice(tp);
        }
    }
    setPricesToShow() {
        const idea = this.get('idea');
        const ins = idea.instrument;
        const sltpOffsetMode = WDSettings.isSlTpInOffset;
        const slRes = this.calculatePriceToShow({
            mainPrice: idea.slPrice,
            sllPrice: idea.sllPrice,
            price: idea.limitPrice,
            priceType: idea.slPriceType,
            isInOffset: idea.slPriceType !== SlTpPriceType.Absolute,
            sltpOffsetMode,
            isBuy: idea.buySide,
            ins
        });
        const tpRes = this.calculatePriceToShow({
            mainPrice: idea.tpPrice,
            sllPrice: null,
            price: idea.limitPrice,
            priceType: idea.tpPriceType,
            isInOffset: idea.tpPriceType !== SlTpPriceType.Absolute,
            sltpOffsetMode,
            isBuy: idea.buySide,
            ins
        });
        this.formatPrices({
            idea,
            sl: slRes,
            tp: tpRes.main,
            ins,
            slType: idea.slPriceType,
            slOffsetType: SlTpUtils.getVisualOffsetType(ins, idea.slPriceType),
            tpOffsetType: SlTpUtils.getVisualOffsetType(ins, idea.tpPriceType),
            sltpOffsetMode
        });
        idea.limitPriceToShow = ins.formatPrice(idea.limitPrice);
        const locKey = isNullOrUndefined(idea.sllPriceToShow) ? 'property.Stop-loss' : 'property.Stop-loss-SLL';
        void this.set('stopLossTitle', Resources.getResource(locKey) + ':');
        void this.set('idea', idea);
        this.setDataIdea();
    }
    // #region Chart
    subscribe(instrument) {
        if (isNullOrUndefined(instrument))
            return;
        if (this.subscribedInstrument === instrument)
            return;
        DataCache.FQuoteCache.addListener(instrument, this, HistoryType.QUOTE_LEVEL1);
        this.subscribedInstrument = instrument;
    }
    unsubscribe(instrument) {
        var _a, _b;
        const ins = instrument !== null && instrument !== void 0 ? instrument : this.subscribedInstrument;
        if (isNullOrUndefined(ins))
            return;
        DataCache.FQuoteCache.removeListener(ins, this, HistoryType.QUOTE_LEVEL1);
        (_b = (_a = this.chart) === null || _a === void 0 ? void 0 : _a.unsubscribeCashItemFromInstrument) === null || _b === void 0 ? void 0 : _b.call(_a);
        if (this.subscribedInstrument === ins) {
            this.subscribedInstrument = null;
        }
    }
    initChart(instrument) {
        var _a;
        this.terceraChartRactive = this.Controls.chart;
        const terceraChart = this.chart;
        terceraChart.windowsContainer.scrollerRenderer.TurnOffRenderer();
        const controller = terceraChart.chartController;
        this.unsubscribe();
        this.subscribe(instrument);
        controller.ExecuteCommand(new TerceraChartMVCCommand(ModelDataType.Instrument), instrument);
        const acc = (_a = this.get('account')) !== null && _a !== void 0 ? _a : DataCache.getPrimaryAccount();
        controller.ExecuteCommand(new TerceraChartMVCCommand(ModelDataType.Account), acc);
        controller.SuspendRefreshChart = false;
        terceraChart.RefreshChart();
        terceraChart.GetContextMenuItems = () => {
            return [];
        };
        this.initChartSettings();
        this.initChartTheme();
        this.setChartSizes();
        this.updateTimeFrameComboBox();
    }
    initChartSettings() {
        var _a;
        const terceraChart = this.chart;
        if (isNullOrUndefined(terceraChart))
            return;
        const controller = terceraChart.chartController;
        controller.terceraChart.model.SetChartDrawingType(TerceraChartDrawingType.Solid); // Line style
        terceraChart.TerceraChartFont.Height = 10;
        const tradingToolsRenderer = terceraChart.TerceraChartTradingToolsRenderer;
        if (!isNullOrUndefined(tradingToolsRenderer)) {
            tradingToolsRenderer.ShowOrders = false;
            tradingToolsRenderer.ShowPositions = false;
            tradingToolsRenderer.ShowVisualTradingOnLeftSide = false;
            tradingToolsRenderer.ShowEvents = false;
            tradingToolsRenderer.ShowAlerts = false;
        }
        const yScaleRendererSettings = terceraChart.yScaleRendererSettings;
        if (!isNullOrUndefined(yScaleRendererSettings)) {
            yScaleRendererSettings.ScaleGridVisibility = false;
            yScaleRendererSettings.AutoScaleSwitcherVisible = false;
        }
        const xScaleRendererSettings = terceraChart.xScaleRendererSettings;
        if (!isNullOrUndefined(xScaleRendererSettings)) {
            xScaleRendererSettings.ScaleGridVisibility = false;
        }
        if (!isNullOrUndefined(terceraChart.TerceraChartInfoWindowRenderer)) {
            terceraChart.TerceraChartInfoWindowRenderer.Visible = false;
        }
        if (!isNullOrUndefined(terceraChart.TerceraChartNewAlertRenderer)) {
            terceraChart.TerceraChartNewAlertRenderer.Visible = false;
        }
        if (!isNullOrUndefined((_a = terceraChart.windowsContainer) === null || _a === void 0 ? void 0 : _a.scrollerRenderer)) {
            terceraChart.windowsContainer.scrollerRenderer.Visible = false;
        }
    }
    initChartTheme() {
        const terceraChart = this.chart;
        if (isNullOrUndefined(terceraChart))
            return;
        const theme = ThemeManager.colors;
        terceraChart.TerceraChartWatermarkRenderer.ForeBrush = new SolidBrush(theme.ChartWatermarkColor);
        const yScaleRendererSettings = terceraChart.yScaleRendererSettings;
        const readIdeaBackGroundColor = theme.detachedScrollBackgroundColor;
        if (!isNullOrUndefined(yScaleRendererSettings)) {
            yScaleRendererSettings.scaleTextBrush = new SolidBrush(readIdeaBackGroundColor);
            yScaleRendererSettings.ScaleBackColor = readIdeaBackGroundColor;
            yScaleRendererSettings.scaleAxisPen.Color = readIdeaBackGroundColor;
        }
        const xScaleRendererSettings = terceraChart.xScaleRendererSettings;
        if (!isNullOrUndefined(xScaleRendererSettings)) {
            xScaleRendererSettings.scaleTextBrush = new SolidBrush(readIdeaBackGroundColor);
            xScaleRendererSettings.ScaleBackColor = readIdeaBackGroundColor;
            xScaleRendererSettings.scaleAxisPen.Color = readIdeaBackGroundColor;
        }
        this.terceraChartRactive.set('backgroundColorBottom', readIdeaBackGroundColor);
    }
    setChartSizes() {
        this.terceraChartRactive.setSizes();
    }
    updateTimeFrameComboBox() {
        if (isNullOrUndefined(this.chart))
            return;
        const cBox = this.Controls.timeFrameComboBox;
        const newItems = [
            {
                type: NewContextMenuItemType.Default,
                text: Periods.ToLocalizedShortPeriod(Periods.MIN),
                value: Periods.MIN
            },
            {
                type: NewContextMenuItemType.Default,
                text: Periods.ToLocalizedShortPeriod(Periods.MIN5),
                value: Periods.MIN5
            },
            {
                type: NewContextMenuItemType.Default,
                text: Periods.ToLocalizedShortPeriod(Periods.MIN15),
                value: Periods.MIN15
            },
            {
                type: NewContextMenuItemType.Default,
                text: Periods.ToLocalizedShortPeriod(Periods.MIN30),
                value: Periods.MIN30
            },
            {
                type: NewContextMenuItemType.Default,
                text: Periods.ToLocalizedShortPeriod(Periods.HOUR),
                value: Periods.HOUR
            },
            {
                type: NewContextMenuItemType.Default,
                text: Periods.ToLocalizedShortPeriod(Periods.HOUR4),
                value: Periods.HOUR4
            },
            {
                type: NewContextMenuItemType.Default,
                text: Periods.ToLocalizedShortPeriod(Periods.DAY),
                value: Periods.DAY
            },
            {
                type: NewContextMenuItemType.Default,
                text: Periods.ToLocalizedShortPeriod(Periods.WEEK),
                value: Periods.WEEK
            },
            {
                type: NewContextMenuItemType.Default,
                text: Periods.ToLocalizedShortPeriod(Periods.MONTH),
                value: Periods.MONTH
            }
        ];
        if (Resources.isHidden('chart.AllowedPeriods.1T')) {
            newItems.splice(0, 1);
        }
        cBox.set('items', newItems);
        const tf = this.chart.TimeFrameInfo();
        if (!isNullOrUndefined(tf)) {
            cBox.setItembyValue(tf.Periods);
        }
    }
    // #endregion chart
    srcFromLogoBytes(logoBytes) {
        let logo = ThemeManager.colors.IdeasPanelDefaultAnalystLogo;
        try {
            if (isValidArray(logoBytes)) {
                const bytes = new Uint8Array(logoBytes);
                const str = String.fromCodePoint(...bytes);
                logo = 'data:image/png;base64,' + btoa(str);
            }
        }
        catch (ex) {
            ErrorInformationStorage.GetException(ex);
        }
        return logo;
    }
    localize() {
        void this.set({
            textAgreeButton: Resources.getResource('panel.Ideas.riskDisclosure.agreeBtnTxt'),
            quantityLabel: Resources.getResource('panel.newOrderEntry.amountLabel') + ':',
            descriptionOpenedTitle: Resources.getResource('InstrumentDetailsPanel.Description') + ':',
            takeProfitTitle: Resources.getResource('property.Take-profit') + ':',
            limitPriceTitle: Resources.getResource('panel.newOrderEntry.limitPricePanel') + ':',
            stopLossTitle: Resources.getResource('property.Stop-loss') + ':',
            attachmentsFile: Resources.getResource('panel.Ideas.AttachmentFile') + ': ',
            attachmentsScreen: Resources.getResource('panel.Ideas.AttachmentScreen') + ': ',
            orderButtonTextBuy: Resources.getResource('panel.Ideas.orderButtonTextBuy'),
            orderButtonTextSell: Resources.getResource('panel.Ideas.orderButtonTextSell')
        });
        const timeFrameCB = this.Controls.timeFrameComboBox;
        if (!isNullOrUndefined(timeFrameCB)) {
            timeFrameCB.set('tooltip', Resources.getResource('chart.agregationType.Button.ToolTip'));
        }
        this.updateTimeFrameComboBox();
    }
    onTimeFrameComboBox_ComboItemClicked(_context, newVal) {
        const chart = this.chart;
        if (isNullOrUndefined(chart) || isNullOrUndefined(newVal))
            return;
        const oldTFInfo = chart.TimeFrameInfo();
        chart.chartController.ExecuteCommand(new TerceraChartMVCCommand(ModelDataType.TFI), oldTFInfo.Copy({ period: newVal.tag }));
    }
    ideaHide() {
        const idea = this.get('idea');
        if (isNullOrUndefined(idea)) {
            return;
        }
        if (!this.get('isOpenIdea')) {
            return;
        }
        this.unsubscribe();
        void this.set({
            isOpenIdea: false,
            isDescriptionOpen: false,
            dataSourceOpen: false
        });
    }
}
ContainerControl.extendWith(IdeasItemSideBar, {
    template: IdeasItemSideBarTemplate,
    data: () => {
        return {
            idea: null,
            name: '',
            title: '',
            companyName: '',
            instrumentLabel: null,
            buySide: null,
            logoSrcBytes: null,
            lifeTime: null,
            descriptionParsedToHTML: '',
            tpPriceToShowFormatted: null,
            tpProfit: null,
            limitPriceToShow: null,
            slPriceToShowFormatted: null,
            slProfit: null,
            hasAttachments: null,
            AttachmentFilePath: null,
            attachExtension: null,
            AttachmentScreenPath: null,
            side: null,
            quantity: null,
            quantityLabel: '',
            quantityVisible: true,
            descriptionOpenedTitle: '',
            isDescriptionOpen: false,
            instrumentItem: null,
            account: null,
            singleAccount: true,
            productType: null,
            productTypeLabel: '',
            productTypeShow: false,
            leverageShow: false,
            leverageValue: null,
            productTypeChangeConfirmationIsInFocus: false,
            tradingAllowed: true,
            tradingForbiddenReason: '',
            takeProfitTitle: '',
            limitPriceTitle: '',
            stopLossTitle: '',
            descrBtnVisible: false,
            dataSourceOpen: false,
            dataSourceVisible: false,
            attachmentsFile: '',
            attachmentsScreen: '',
            orderButtonTextBuy: '',
            orderButtonTextSell: '',
            estQtyValue: null, // for recountLossAndProfit
            cash: null,
            isCashMode: false,
            orderType: null, // always Limit, but needs to declare here for CashTrading
            isOpenIdea: false
        };
    },
    computed: {
        terceraChartPanelContext: {
            get() {
                return this;
            },
            set(_v) { }
        },
        visibleButtonsBarState: {
            get() {
                return isNullOrUndefined(this.get('idea')) ? 'hidden' : '';
            },
            set(_v) { }
        }
    }
});
